<template>
  <generic-modal
    size="large"
    :title="$t('onfido verification')"
    icon="id card"
    image="/images/icons/onfido.jpeg"
    :show_ok="false"
    :scrolling="true"
    v-on:destroy="$emit('close')"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div class="ui grid">
        <div class="two column row">
          <div class="column">
            <div class="ui header">
              <i
                class="thermometer half icon"
                v-bind:class="{
                  green: greens.includes(verification.status_code),
                }"
              ></i>
              <div class="content" v-if="verification.check_status_result">
                {{ verification.check_status_result.status }}
                <div class="sub header">{{ $t("status") }}</div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="ui header">
              <i
                class="flag checkered icon"
                v-bind:class="{
                  green: greens.includes(verification.check_result),
                  red: reds.includes(verification.check_result),
                }"
              ></i>
              <div class="content">
                {{ verification.check_result }}
                <div class="sub header">{{ $t("result") }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div
              class="ui header"
              v-if="
                verification &&
                  verification.check_request_response &&
                  verification.check_request_response.resultsUri
              "
            >
              <i class="linkify icon"></i>
              <div class="content">
                {{ $t("onfido link") }}
                <a
                  class="sub header"
                  target="_blank"
                  :href="verification.check_request_response.resultsUri"
                  >{{ verification.check_request_response.resultsUri }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <h4 class="ui dividing header">{{ $t("reports") }}</h4>
      <div class="ui top attached tabular menu" ref="reports">
        <a
          class="item"
          v-bind:class="{ active: idx == 0 }"
          :data-tab="rpt.id"
          v-for="(rpt, idx) in verification.check_result_detail"
          :key="idx"
        >
          <i :class="chkicon(rpt) + ' icon'"></i> {{ $t(rpt.name) }}
        </a>
      </div>
      <div
        class="ui bottom attached tab segment"
        v-bind:class="{
          active: idx == 0,
          green: greens.includes(rpt.result),
          red: reds.includes(rpt.result),
        }"
        :data-tab="rpt.id"
        v-for="(rpt, idx) in verification.check_result_detail"
        :key="idx"
      >
        <div class="ui grid">
          <div class="three column row">
            <div class="column">
              <div class="ui header">
                <i class="thermometer half icon"></i>
                <div class="content">
                  {{ rpt.status }}
                  <div class="sub header">{{ $t("status") }}</div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="ui header">
                <i
                  class="flag checkered icon"
                  v-bind:class="{
                    green: greens.includes(rpt.result),
                    red: reds.includes(rpt.result),
                  }"
                ></i>
                <div class="content">
                  {{ rpt.result }}
                  <div class="sub header">{{ $t("result") }}</div>
                </div>
              </div>
            </div>
            <div class="column" v-if="rpt.sub_result">
              <div class="ui header">
                <i class="flag icon"></i>
                <div class="content">
                  {{ rpt.sub_result }}
                  <div class="sub header">{{ $t("sub-result") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui basic segment" v-if="rpt.breakdown_">
          <h4 class="ui dividing header">{{ $t("breakdown") }}</h4>

          <div class="ui grid">
            <div class="six wide column">
              <div class="ui vertical fluid tabular menu">
                <a
                  class="item"
                  :data-tab="brk.id"
                  v-bind:class="{ active: _idx == 0 }"
                  v-for="(brk, _idx) in rpt.breakdown_"
                  :key="_idx"
                >
                  <i :class="chkicon(brk.value) + ' icon'"></i> {{ brk.name }}
                </a>
              </div>
            </div>
            <div class="ten wide stretched column">
              <div
                class="ui bottom attached tab segment"
                v-bind:class="{
                  active: _idx == 0,
                  green: greens.includes(brk.value.result),
                  red: reds.includes(brk.value.result),
                }"
                :data-tab="brk.id"
                v-for="(brk, _idx) in rpt.breakdown_"
                :key="_idx"
              >
                <div class="ui header" v-if="brk.value.result">
                  <i
                    class="flag checkered icon"
                    v-bind:class="{
                      green: greens.includes(brk.value.result),
                      red: reds.includes(brk.value.result),
                    }"
                  ></i>
                  <div class="content">
                    {{ brk.value.result }}
                    <div class="sub header">{{ $t("result") }}</div>
                  </div>
                </div>

                <div class="ui dividing header">{{ $t("properties") }}</div>

                <div class="ui bulleted list">
                  <div
                    class="item"
                    v-for="(_brk, __idx) in brk.value.breakdown_"
                    :key="__idx"
                  >
                    <span
                      ><i
                        class="icon"
                        v-bind:class="{
                          active: __idx == 0,
                          'green check': greens.includes(_brk.value.result),
                          'red remove': reds.includes(_brk.value.result),
                          'orange info': !_brk.value.result,
                        }"
                      ></i>
                      {{ _brk.name }}
                      <strong>[{{ _brk.value.result }}]</strong></span
                    >
                    <div class="list" v-if="_brk.value.properties_.length > 0">
                      <div
                        class="item"
                        v-for="(p, ___idx) in _brk.value.properties_"
                        :key="___idx"
                      >
                        <span
                          ><i
                            class="icon"
                            v-bind:class="{
                              active: __idx == 0,
                              'green check': greens.includes(_brk.value.result),
                              'red remove': reds.includes(_brk.value.result),
                            }"
                          ></i>
                          {{ _brk.name }}
                          {{ p.name }} <strong>[{{ p.value }}]</strong></span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="ui one cards">
                  <div
                    class="card"
                    v-for="(_brk, __idx) in brk.value.breakdown_"
                    v-bind:class="{
                      green: greens.includes(_brk.value.result),
                      red: reds.includes(_brk.value.result),
                    }"
                    :key="__idx"
                  >
                    <div class="content">
                      <div class="header">
                        <i
                          class="check icon"
                          v-bind:class="{
                            active: __idx == 0,
                            green: greens.includes(_brk.value.result),
                            red: reds.includes(_brk.value.result),
                          }"
                        ></i>
                        <span v-if="_brk.value.result">{{
                          _brk.value.result
                        }}</span
                        ><span v-if="!_brk.value.result">{{ _brk.name }}</span>
                      </div>
                      <div class="meta" v-if="_brk.value.result">
                        {{ _brk.name }}
                      </div>
                      <div class="description">
                        <div
                          class="ui bulleted list"
                          v-if="_brk.value.properties_.length > 0"
                        >
                          <div
                            class="item"
                            v-for="(p, ___idx) in _brk.value.properties_"
                            :key="___idx"
                          >
                            {{ p.name }} <strong>[{{ p.value }}]</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import { v4 } from "uuid";

export default {
  name: "OnfidoConnectVerificationModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  data() {
    return {
      verification: {},
      footer_buttons: [],
      greens: ["clear", "complete"],
      reds: ["consider", "unidentified"],
    };
  },
  methods: {
    updateVerification(verification_uuid) {
      let vm = this;
      local_api(this, "post", "/onfido_connect/do-get", {
        u: verification_uuid,
      })
        .then((verification) => {
          vm.verification = verification;

          if (verification && verification.check_result_detail) {
            verification.check_result_detail = verification.check_result_detail.map(
              (r) => {
                if (r.breakdown) {
                  r.breakdown_ = Object.keys(r.breakdown).map((e) => {
                    let trgt = r.breakdown[e];
                    if (trgt.breakdown) {
                      trgt.breakdown_ = Object.keys(trgt.breakdown).map((j) => {
                        let _trgt = trgt.breakdown[j];
                        if (_trgt.properties) {
                          _trgt.properties_ = Object.keys(_trgt.properties).map(
                            (p) => {
                              let __trgt = _trgt.properties[p];
                              return { name: p, id: v4(), value: __trgt };
                            },
                          );
                        }

                        return { name: j, id: v4(), value: _trgt };
                      });
                    }

                    return { name: e, id: v4(), value: trgt };
                  });
                }
                return r;
              },
            );
          }

          setTimeout(() => {
            window.jQuery(".ui.menu .item").tab();
          }, 500);
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    chkicon: function(rpt) {
      if (this.greens.includes(rpt.result)) return "green check";
      else if (this.reds.includes(rpt.result)) return "red remove";
      return "info";
    },
  },
  mounted() {
    // window.jQuery(".ui.menu .item").tab();
  },
  watch: {},
  updated: function() {},
};
</script>
